import { configureStore } from '@reduxjs/toolkit'
import { setupListeners } from '@reduxjs/toolkit/query/react'
import { TypedUseSelectorHook, useSelector } from 'react-redux'

// Services
import api from '@/services/api'
import { rtkQueryErrorLogger } from '@/services/lib/error'

// Slices
import account from './accountSlice'
import nps from './npsSlice'
import theme from './themeSlice'

const store = configureStore({
  reducer: {
    account,
    theme,
    nps,
    [api.reducerPath]: api.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(api.middleware, rtkQueryErrorLogger),
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector

setupListeners(store.dispatch)

export default store
